export default __webpack_public_path__ + "static/media/branding-medium-webfont.c3ae1696.woff2";